import Vue from 'vue'
import { beforeRouteEnter } from '@assets/js/routerPageHook.js'
import PageForm from '@shared/ui/public/forms/PageForm.vue'
import BannerBtn from '@components/ui-components/banner-btn/component.js'
import { mapActions, mapState } from 'vuex'
import { router } from '@src/routes'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
      coordinates: [0, 0],
      iconMap: {
        layout: 'default#image', // 'default#imageWithContent' для использования с контентом
        imageHref: '/dist/img/iconMap.svg', // адрес изображения или data:image/svg+xml;base64
        imageSize: [50, 64], // размер иконки в px
        imageOffset: [-25, -80], // смещение иконки в px,
      },
      visibleCurtainCtrl: false,
      ctrlKey: false,
    }
  },
  components: {
    'page-form-cmp': PageForm,
    'banner-btn-cmp': BannerBtn,
  },
  computed: {
    ...mapState('mobile', ['isMobile']),
  },
  methods: {
    ...mapActions('modal', ['modalType_contactsOpen', 'modalType_collabOpen', 'modalClose']),
    initMap(obj) {
      let ctrlMessVisible = false
      let timer
      let context = this

      obj.behaviors.disable('scrollZoom')

      // Отслеживаем скролл мыши на карте, чтобы показывать уведомление
      obj.events.add(['wheel', 'mousedown'], function(e) {
        if (e.get('type') === 'wheel') {
          if (!context.ctrlKey) {
            // Ctrl не нажат, показываем уведомление
            context.visibleCurtainCtrl = true
            ctrlMessVisible = true
            clearTimeout(timer) // Очищаем таймер, чтобы продолжать показывать уведомление
            timer = setTimeout(function() {
              context.visibleCurtainCtrl = false
              ctrlMessVisible = false
            }, 1500)
          } else {
            // Ctrl нажат, скрываем сообщение
            context.visibleCurtainCtrl = false
          }
        }
        if (e.get('type') === 'mousedown' && ctrlMessVisible) {
          // Скрываем уведомление при клике на карте
          context.visibleCurtainCtrl = false
        }
      })

      // Обрабатываем нажатие на Ctrl
      window.addEventListener('keydown', function(e) {
        // Ctrl нажат: включаем масштабирование мышью
        if (e.which === 17 && !context.ctrlKey) {
          context.ctrlKey = true
          obj.behaviors.enable('scrollZoom')
        }
      })
      window.addEventListener('keyup', function(e) {
        // Ctrl не нажат: выключаем масштабирование мышью
        if (e.which === 17) {
          context.ctrlKey = false
          obj.behaviors.disable('scrollZoom')
        }
      })
    },
    addressToCoordinates() {
      let address = this.$refs.addressMap.innerText
      let city = this.$refs.cityMap.innerText + ', '

      if (address) {
        Vue.http
          .get('https://geocode-maps.yandex.ru/1.x', {
            params: {
              geocode: city + address,
              apikey: '6ac4f4c1-94f6-4433-a1a4-72fd0656a4d1',
              format: 'json',
              // rspn: 1,
              // results: 10,
            },
          })
          .then(response => response.json())
          .then(data => {
            if (data.response.GeoObjectCollection.featureMember[0]) {
              this.coordinates = data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(' ')
              this.coordinates.reverse()
            }
          })
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.addressToCoordinates()
    }, 100)
  },
  beforeRouteUpdate(to, from, next) {
    const path = to.path.replace(router.history.base, '')

    Vue.http.get(`templates${path}`, { params: to.query }).then(
      data => {
        next()
        this.template = data.data
        setTimeout(() => {
          this.addressToCoordinates()
        }, 100)
      },
      () => {
        next('/404')
      }
    )
  },
  beforeRouteEnter,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/contacts/index.js